import { JsonUtils } from "../../utils/json.util"

export class Ngo {
    private _id: string | undefined
    private _local: string | undefined
    private _telephone: string | undefined
    private _telephone_support: string | undefined
    private _instagram: string | undefined
    private _whatsapp: string | undefined
    private _facebook: string | undefined
    private _pix: string | undefined
    private _about: string | undefined

    get id(): string | undefined {
        return this._id
    }

    set id(value: string | undefined) {
        this._id = value
    }

    get local(): string | undefined {
        return this._local
    }

    set local(value: string | undefined) {
        this._local = value
    }
    get telephone(): string | undefined {
        return this._telephone
    }

    set telephone(value: string | undefined) {
        this._telephone = value
    }
    get telephone_support(): string | undefined {
        return this._telephone_support
    }

    set telephone_support(value: string | undefined) {
        this._telephone_support = value
    }

    get instagram(): string | undefined {
        return this._instagram
    }

    set instagram(value: string | undefined) {
        this._instagram = value
    }

    get whatsapp(): string | undefined {
        return this._whatsapp
    }

    set whatsapp(value: string | undefined) {
        this._whatsapp = value
    }
    get facebook(): string | undefined {
        return this._facebook
    }

    set facebook(value: string | undefined) {
        this._facebook = value
    }

    get pix(): string | undefined {
        return this._pix
    }

    set pix(value: string | undefined) {
        this._pix = value
    }
    get about(): string | undefined {
        return this._about
    }

    set about(value: string | undefined) {
        this._about = value
    }
    // metodo responsavel por formatar os dados do backend para frontend
    public fromJSON(json: any): Ngo {
        if (!json) {

            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }
        if (json.id !== undefined) {
            this.id = json.id
        }
        if (json.local !== undefined) {
            this.local = json.local
        }
        if (json.telephone !== undefined) {
            this.telephone = json.telephone
        }
        if (json.telephone_support !== undefined) {
            this.telephone_support = json.telephone_support
        }
        if (json.instagram !== undefined) {
            this.instagram = json.instagram
        }
        if (json.whatsapp !== undefined) {
            this.whatsapp = json.whatsapp
        }
        if (json.facebook !== undefined) {
            this.facebook = json.facebook
        }
        if (json.pix !== undefined) {
            this.pix = json.pix
        }
        if (json.about !== undefined) {
            this.about = json.about
        }
        return this
    }
    // metodo responsavel para formatar os dados do front para o back
    public toJSON(): any {
        return {
            id: this.id || undefined,
            local: this.local || undefined,
            telephone: this.telephone || undefined,
            telephone_support: this.telephone_support || undefined,
            instagram: this.instagram,
            whatsapp: this.whatsapp,
            facebook: this.facebook,
            pix: this.pix || undefined,
            about: this.about || undefined,

        }
    }
}